import template from '../helpers/template';
import log from '../helpers/log';
import slider from '../helpers/slider';
import query from '../helpers/query';
import reveal from '../helpers/reveal';

interface IConfig {
  productDir: string,
  localStorageKey: string,
  maxProducts: number,
  minProducts: number,
  content: string,
  slider: string
  view: string,
  hideClass: string,
  container: string
}

class RecentlyViewed {

  private config:IConfig;

  constructor() {
    this.config = {
      productDir: '/products/',
      localStorageKey: 'recentlyViewed',
      maxProducts: 6,
      minProducts: 6,
      view: 'recently-viewed',
      content: '[data-recently-viewed-content]',
      slider: '[data-recently-viewed-slider]',
      hideClass: 'hide',
      container: '[data-recently-viewed]'
    }
  }

  init() {
    if (window.location.pathname.includes(this.config.productDir)) this.updateLocalStorage();
    const nodeList = document.querySelectorAll(this.config.container);
    if (nodeList.length) {
      this.renderAll(nodeList);
    }
  }

  renderAll(nodeList:NodeList) {
    let handles:string[];

    try {
      handles = JSON.parse(window.localStorage.getItem(this.config.localStorageKey));
    }
    catch(error) {
      log.error(error);
    }
    
    if (handles && handles.length >= this.config.minProducts) nodeList.forEach((node:HTMLElement) => this.render(node, handles));
  }

  async render(node:HTMLElement, handles: string[]) {
    try {
      const url = query.buildURL({
        type: 'product',
        operator: 'OR',
        handles: handles
      });

      await template.getAndUpdateHTML({
        node: node, 
        content: this.config.content, 
        url: url, 
        view: this.config.view
      });

      this.slider(node);
      reveal.closestHideClassName(node);
    } catch(error) {
      log.error(error);
    }
  }

  slider(node:HTMLElement) {
    const sliderNode:HTMLElement = node.querySelector(this.config.slider);
    if (sliderNode) slider.init(sliderNode, { items: 2.5 });
  }

  reveal(node:HTMLElement) {
    node.classList.remove(this.config.hideClass);
  }

  updateLocalStorage() {
    try {
      const paths = window.location.pathname.split('/');
      const handle = paths[paths.length - 1];
      const localHandles = JSON.parse(window.localStorage.getItem(this.config.localStorageKey));
      let handles:any = new Set(localHandles);
      if (handles.size == this.config.maxProducts) handles.delete(handles.values().next().value);
      handles.add(handle);
      window.localStorage.setItem(this.config.localStorageKey, JSON.stringify(Array.from(handles)));
    }
    catch(error) {
      console.error(error);
    }
  }
}

export default new RecentlyViewed();